import { useMemo } from 'react';
import { Owner } from '../types/Owner';

const useFilteredOwners = (
    owners: Owner[] = [],
    searchText: string,
    selectedTypes: string[]
) => {
    return useMemo(() => {
        if (!owners || owners.length === 0) {
            return [];
        }

        return owners.filter(owner => {
            const typeLabel = owner.car ? 'машина' : 'сотрудник';
            const matchesSearch =
                (owner.name?.toLowerCase() || '').includes(searchText.toLowerCase()) ||
                typeLabel.includes(searchText.toLowerCase());
            const matchesType = selectedTypes.length === 0 || selectedTypes.includes(typeLabel);
            return matchesSearch && matchesType;
        });
    }, [owners, searchText, selectedTypes]);
};

export default useFilteredOwners; 